import { morphSection } from '@theme/section-renderer';

if (!customElements.get('gift-bag-option')) {
  customElements.define(
    'gift-bag-option',
    class GiftBagOption extends HTMLElement {
      connectedCallback() {
        this.inputs = [...this.querySelectorAll('.gift-bag__input')];
        this.inputs.forEach((input) => input.addEventListener('change', this.onChange));
      }

      disconnectedCallback() {
        this.inputs?.forEach((input) => input.removeEventListener('change', this.onChange));
      }

      // The gift bag and the premium package are alternatives: choosing one removes the other.
      onChange = async (event) => {
        const input = event.currentTarget;
        const { sectionId } = this.dataset;
        const sections = sectionId ? [sectionId] : [];
        const previous = this.inputs.map((item) => item.checked);
        const updates = { [input.dataset.variantId]: input.checked ? 1 : 0 };

        if (input.checked) {
          this.inputs.forEach((other) => {
            if (other !== input && other.checked) {
              other.checked = false;
              updates[other.dataset.variantId] = 0;
            }
          });
        }

        this.classList.add('is-loading');
        try {
          const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates, sections }),
          });
          if (!response.ok) throw new Error('Cart update failed');
          const data = await response.json();
          const html = data.sections?.[sectionId];
          if (html) await morphSection(sectionId, html);

          const cart = await fetch(`${Shopify.routes.root}cart.js`).then((r) => r.json());
          document.querySelectorAll('[data-cart-count]').forEach((badge) => {
            badge.textContent = String(cart.item_count);
            badge.hidden = cart.item_count === 0;
          });
        } catch (error) {
          // `previous` was read after the click, so restore it and flip the clicked option back
          this.inputs.forEach((item, index) => (item.checked = previous[index]));
          input.checked = !input.checked;
          console.error(error);
        } finally {
          this.classList.remove('is-loading');
        }
      };
    }
  );
}
